export default {
    namespaced: true,
    state: {
        pagina:  'CASTELLON SENIOR',

        //url:     'https://iberopa.com/abk/exec.php',
        //urlTMP:  'https://iberopa.com/abk/tmp/',
        url:     '',
        urlTMP:  '',
        //
        url_img: 'https://iberopa.com/_abk/lib/imagendb.php',
        url_tmp: 'https://iberopa.com/_abk/tmp/',
        url_tpv: 'https://iberopa.com/abks/adm.cemo/tpv_pago1.php',
        url_tpv1:'https://iberopa.com/_abk/adm/vc/tpv_pago1.php',

        PRODUCTION: true,

        abk_url: {
            app:    'vc',
            api:    'castellon',
            accion: '',
            tipo:   '',
            args:   [],
            version: '1.0'
        },


    },
    mutations: {
        set_URLS(state) {
            let prefijo= state.PRODUCTION ? '' : 'app.';

            let url= "https://" + prefijo + "iberopa.com/abk/";

            //enrutador y tmp
            state.url=`${url}exec.php`
            state.urlTMP=`${url}tmp/`

            //state.informesURL= state.infadm + "abk_141220/vue/enrutador.php",
            //state.informesURL= state.infadm + "abk/proxy.php";
            //state.inf_tmp= state.infadm + "abk/tmp/";

          },
    },
    actions: {
    },
    getters: {
    }
}